import { Component } from '@angular/core';

@Component({
  selector: 'app-secure-deal-dialog',
  templateUrl: './secure-deal-dialog.component.html',
  styleUrls: ['./secure-deal-dialog.component.scss']
})
export class SecureDealDialogComponent {

  constructor() { }

}
